import { ApiService } from './api.service'

const BaseUrl = '/service-request'

export function afadRequest (params = {}) {
  return ApiService.post(`${BaseUrl}`, params).then(resp => resp.data)
}
